import { makeAutoObservable } from "mobx";


class ParsingPageStore {
  isPeriodic = false;
  intervalValue = "";
  intervalUnit = "";
  repeatForever = false;
  overlapValue = "0";
  overlapUnit = "minutes";
  depth = 1;
  reps = "";

  constructor() {
    makeAutoObservable(this);
  }

  setIsPeriodic(value) {
    this.isPeriodic = value;
    if (!value) {
      this.repeatForever = false;
    }
  }

  setIntervalValue(value) {
    this.intervalValue = value;
  }

  setIntervalUnit(value) {
    this.intervalUnit = value;
  }

  setRepeatForever(value) {
    this.repeatForever = value;
  }

  setOverlapValue(value) {
    this.overlapValue = value;
  }

  setOverlapUnit(value) {
    this.overlapUnit = value;
  }

  setDepth(value) {
    this.depth = value;
  }

  setReps(value) {
    this.reps = value;
  }
}

export default new ParsingPageStore();
